<!--
    @修改人：黎柏祺
    @修改时间：2018-10-24
    @修改描述：框架升级
    @版本:v1.0.26
    ------------
	  @负责人: 谢汉
    @创建时间: 2018-07-09
    @版本:v1.0.18
    @描述: 主机地图模块详情页
    -->
<template>
  <div class="hostMonitorModule__content content-wrap">
    <back :history="history"></back>
    <div>
      <div class="moduleName">{{ department }}</div>
      <div class="moduleInfo">
        <div>
          <span v-text="$t('hostMapping.moduleName') + '：' + moduleName" class="mr50 lock-width"></span>
          <span v-text="$t('hostMapping.total') + '：' + totalHostNum"></span>
        </div>
        <div>
          <span v-text="$t('hostMapping.powerOn') + '：' + powerOnNum" class="mr50 lock-width"></span>
          <span v-text="$t('hostMapping.powerOff') + '：' + powerOffNum"></span>
        </div>
      </div>
      <div class="moduleName">{{ $t('hostMapping.machine') }}</div>
      <div class="ip-list-wrap"
        v-for="(item,index) in hostInfo"
        :class="{ 'ip-list-wrap-off' : item.status == 2 }"
        @click="checkIP(item)"
        :title="item.appText"
        :key="index">
        <div v-text="item.ip1"></div>
      </div>
      <div v-show="hostInfo.length == 0" style="text-align: center;">{{ $t('hostMapping.noData') }}</div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import hostMappingBiz from '@/logic/intelligentMonitor/hostMappingBiz.js'
  import back from '@/components/back.vue'

  export default {
    components: {
      back: back
    },
    data () {
      return {
        history: [],
        siteCode: '',
        moduleName: '',
        department: '',
        totalHostNum: 0,
        powerOnNum: 0,
        powerOffNum: 0,
        hostInfo: [],
        clickId: ''
      }
    },
    watch: {
      $route (newValue, oldValue) {
        if (newValue.name === 'hostMappingModule' && oldValue.name === 'hostMappingDetail') {
          this.e_init()
        }
      }
    },
    methods: {
      e_reset () {
        this.hostInfo = []
        this.clickId = ''
        this.powerOnNum = 0
        this.powerOffNum = 0
      },
      e_getModuleInfo () {
        this.e_reset()
        hostMappingBiz.getModule({
          department: this.department,
          siteCode: this.siteCode
        }).then((data) => {
          this.moduleName = data.moduleName
          this.totalHostNum = data.total
          this.hostInfo = data.hostInfo
          this.hostInfo.map((item) => {
            item.status === '2' ? this.powerOffNum++ : this.powerOnNum++
            item.appText = ''
            if (item.applications && item.applications.length > 0) {
              item.applications.map((app, index) => {
                let str = index !== item.applications.length - 1 ? app + '、' : app
                item.appText += str
              })
            } else {
              item.appText = this.$t('hostMapping.none')
            }
          })
          this.setHistory(data.siteName)
        })
      },
      setHistory (siteName) {
        if (siteName) {
          this.history.splice(0, 1, {
            name: siteName,
            path: `/home/hostMapping/hostMappingDetail?siteCode=${this.siteCode}`
          })
          this.history.splice(1, 1, { name: this.department })
        } else {
          this.history = []
          this.history.push({ name: '' })
          if (this.department === '') return
          this.history.push({ name: this.department })
        }
      },
      checkIP (item) {
        this.$router.push({ path: '/home/hostMapping/hostMappingModuleDetail', query: { siteCode: this.siteCode, department: item.department, ip: item.ip1 } })
      },
      e_init () {
        this.siteCode = this.$route.query.siteCode
        this.department = this.$route.query.department
        this.setHistory()
        this.e_getModuleInfo()
      }
    },
    mounted () {
      this.e_init()
    }
  }
</script>
<style scoped>
  .hostMonitorModule__content{
    font-size: 14px;
  }
  .hostMonitorModule__content .noData {
      height: 150px;
      line-height: 150px;
  }
  .hostMonitorModule__content .moduleName {
      font-size: 20px;
      font-weight: bolder;
  }
  .hostMonitorModule__content .moduleInfo {
      padding: 18px;
  }
  .hostMonitorModule__content .lock-width {
      display: inline-block;
      width: 200px;
  }
  .hostMonitorModule__content .ip-list-wrap {
      display: inline-block;
      width: 180px;
      height: 40px;
      line-height: 38px;
      margin: 10px;
      border: 2px solid #13CE66;
  border-radius: 2px;
      color: #13CE66;
      font-weight: bolder;
      text-align: center;
      cursor: pointer;
  box-sizing: border-box;
  }
  .hostMonitorModule__content .ip-list-wrap:hover {
      background: #3385ff;
      color: #fff;
  }
  .hostMonitorModule__content .ip-list-wrap-off {
      border: 2px solid #d3d3d3;
      color: #bdbdbd;
  }
  .hostMonitorModule__content .mr50{
    margin-right: 50px;
  }
</style>